import React from "react";
import TextField from "@material-ui/core/TextField";
import PropTypes from "prop-types";
import { InputAdornment } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";

/**
 * Komponente zur Eingabe von Texten
 * @param id die ID des Textfelds
 * @param error eine darzustellende Fehlermeldung
 * @param loading Gibt an, dass der darzustellende Datensatz geladen wird.
 * @param rest die Properties, welche an das Textfeld weitergeleitet werden Mögliche Parameter u.A.:
 * <ul>
 *     <li>required</li>
 *     <li>label</li>
 *     <li>value</li>
 *     <li>onChange</li>
 * </ul>
 * @returns {JSX.Element}
 * @constructor
 */
function EATextField({ id, error, loading, helperText, ...rest }) {
    const additionalProps = {};

    if (loading) {
        additionalProps.InputProps = {
            endAdornment: (
                <InputAdornment>
                    <CircularProgress style={{ width: "15px", height: "15px" }} />
                </InputAdornment>
            ),
        };
        if (rest.InputProps) {
            additionalProps.InputProps = { ...additionalProps.InputProps, ...rest.InputProps };
        }
    } else if (rest.InputProps) {
        additionalProps.InputProps = { ...rest.InputProps };
    }

    return (
        <TextField
            value={rest.value ?? ""}
            id={id}
            variant="outlined"
            error={Boolean(error)}
            helperText={error || helperText}
            {...rest}
            {...additionalProps}
        />
    );
}

EATextField.propTypes = {
    id: PropTypes.string.isRequired,
};

export default EATextField;
